import { render, staticRenderFns } from "./ExamFinished.vue?vue&type=template&id=5f3189af&scoped=true"
import script from "./ExamFinished.vue?vue&type=script&lang=js"
export * from "./ExamFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3189af",
  null
  
)

export default component.exports